import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { Form } from 'antd';
import AddableRowTable from 'hermes-react/lib/addable-row-table';
const Root = styled.div ``;
const FormItem = Form.Item;
const MENU_LIST_OPTION = {
    0: '一级菜单',
    1: '二级菜单',
    2: '三级菜单',
};
class SortMenuList extends Component {
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { form: { validateFields }, } = this.props;
            const values = yield new Promise((resolve, reject) => {
                validateFields((errs, values) => {
                    if (errs)
                        return reject(errs);
                    resolve(values);
                });
            });
            const validValues = _.reduce(values, (res, v, k) => {
                if (Array.isArray(v)) {
                    res[k] = v.map((item, index) => (Object.assign({}, item, { sequence: index + 1 })));
                }
                return res;
            }, {});
            return validValues;
        });
    }
    render() {
        const { className, style, form, initialValue } = this.props;
        const { getFieldDecorator } = form;
        const options = [
            {
                title: '序号',
                width: 2,
                render: (index) => {
                    return index + 1;
                },
            },
            {
                name: 'name',
                width: 4,
                title: '菜单名称',
                render: (index, formProps) => {
                    return initialValue.children[index]['name'];
                },
            },
            {
                name: 'type',
                width: 4,
                title: '菜单类型',
                render: (index, formProps) => {
                    return (MENU_LIST_OPTION[initialValue.children[index]['type']] ||
                        '-');
                },
            },
            {
                name: 'url',
                width: 14,
                title: '链接地址',
                render: (index, formProps) => {
                    return initialValue.children[index]['url'] || '-';
                },
            },
        ];
        return (<Root className={className} style={style}>
        <Form>
          <FormItem>
            {getFieldDecorator('children', {
            initialValue: initialValue.children,
        })(<AddableRowTable form={form} draggable disabled showOperator options={options}/>)}
          </FormItem>
        </Form>
      </Root>);
    }
}
export default Form.create()(SortMenuList);
